import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GAdsService {
  private DATA_KEY = 'ipk-gads-data';

  constructor() {}

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasUtmParam = Array.from(urlParams.keys()).some((key) => key.includes('utm'));

    if (hasUtmParam) {
      const params = {};
      for (const [key, value] of urlParams.entries()) {
        Object.assign(params, { [key]: value });
      }

      localStorage.setItem(this.DATA_KEY, JSON.stringify(params));
    }
  }

  getData(params: { gclid?: object; fbclid?: object }): object {
    let data: object = JSON.parse(localStorage.getItem(this.DATA_KEY)!);

    if (params.gclid) {
      data = { ...data, gclid: params.gclid };
    }
    if (params.fbclid) {
      data = { ...data, fbclid: params.fbclid };
    }

    return data;
  }

  reset() {
    localStorage.removeItem(this.DATA_KEY);
  }
}
